"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _dotUtils = require("dot-utils");

var _Wrapper = _interopRequireDefault(require("../elements/Wrapper"));

var _Grid = _interopRequireDefault(require("../elements/Grid"));

var _ramda = require("ramda");

var _Input = _interopRequireDefault(require("../form-controls/Input"));

var _Select = _interopRequireDefault(require("../form-controls/Select"));

var _styles = require("../styles");

var _Clickable = _interopRequireDefault(require("../elements/Clickable"));

var _Caption = _interopRequireDefault(require("../elements/Caption"));

var _Text = _interopRequireDefault(require("../elements/Text"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledGrid = (0, _styledComponents["default"])(_Grid["default"]).withConfig({
  displayName: "WidgetsFilter___StyledGrid",
  componentId: "sc-1edd8jb-0"
})(["position:relative;z-index:2;&&{@media (max-width:450px){grid-template-columns:1fr;}}"]);

var _StyledClickable = (0, _styledComponents["default"])(_Clickable["default"]).withConfig({
  displayName: "WidgetsFilter___StyledClickable",
  componentId: "sc-1edd8jb-1"
})(["display:block;text-decoration:underline;&:hover{text-decoration:none;}"]);

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "WidgetsFilter___StyledWrapper",
  componentId: "sc-1edd8jb-2"
})(["position:relative;z-index:1;"]);

function WidgetsFilter(_ref) {
  var widgets = _ref.widgets,
      render = _ref.render,
      props = _objectWithoutProperties(_ref, ["widgets", "render"]);

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filters = _useState4[0],
      setFilters = _useState4[1];

  var rgx = new RegExp(searchQuery, 'ig');
  var filteredWidgets = widgets.filter((0, _ramda.allPass)([function (widget) {
    return rgx.test(JSON.stringify(widget));
  }, function (widget) {
    return (0, _ramda.difference)(filters, Object.values(widget)).length === 0;
  }]));
  return /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], props, /*#__PURE__*/_react["default"].createElement(_StyledGrid, {
    columnLayout: '1fr 1fr',
    gridGap: _styles.baseSpacing,
    mb: _styles.baseSpacing
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    placeholder: 'Search Widgets',
    value: searchQuery,
    onChange: function onChange(e) {
      return setSearchQuery(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    multiple: true,
    value: filters,
    onChange: function onChange(e) {
      setFilters(e.target.value);
    },
    placeholder: 'Filters',
    options: [{
      value: 'type',
      label: 'Widget Type',
      disabled: true
    }, {
      value: _dotUtils.WidgetType.Quiz,
      label: 'Quiz'
    }, {
      value: _dotUtils.WidgetType.Poll,
      label: 'Poll'
    }, {
      value: 'status',
      label: 'Published Status',
      disabled: true
    }, {
      value: _dotUtils.WidgetStatus.Published,
      label: 'Published'
    }, {
      value: _dotUtils.WidgetStatus.Draft,
      label: 'Draft'
    }]
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, "Filters"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true
  }, "Widget Status"), /*#__PURE__*/_react["default"].createElement("option", {
    value: _dotUtils.WidgetStatus.Published
  }, "Published"), /*#__PURE__*/_react["default"].createElement("option", {
    value: _dotUtils.WidgetStatus.Draft
  }, "Draft"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "",
    disabled: true
  }, "Widget Type"), /*#__PURE__*/_react["default"].createElement("option", {
    value: _dotUtils.WidgetType.Quiz
  }, "Quiz"), /*#__PURE__*/_react["default"].createElement("option", {
    value: _dotUtils.WidgetType.Poll
  }, "Poll"))), /*#__PURE__*/_react["default"].createElement(_StyledClickable, {
    component: _Caption["default"],
    mb: _styles.baseSpacing,
    onClick: function onClick() {
      setFilters([]);
      setSearchQuery('');
    },
    textAlign: "center"
  }, "Clear Values"), /*#__PURE__*/_react["default"].createElement(_StyledWrapper, null, filteredWidgets.length && render(filteredWidgets) || /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    p: _styles.baseSpacing * 3,
    textAlign: 'center'
  }, "No Widgets Found")));
}

var _default = WidgetsFilter;
exports["default"] = _default;